import React from "react";

import colorsLight from "../../assets/theme/light/colors";

const TimeEntryStatus = (props) => {

  const { timeEntryStatus } = props;
  const { timeEntryStatusColors } = colorsLight;

  if (!props) return null;
  return (
    <span
    style={{
      padding: "5px 10px",
      borderRadius: "5px",
      fontFamily: "poppins",
      margin: "auto",
      fontSize: "13px",
      width: "90px", 
      textAlign: "center", 
      display: "inline-block", 
      ...timeEntryStatusColors[timeEntryStatus.description],
    }}
  >
    {timeEntryStatus.description}
  </span>
  );
 
};

export default TimeEntryStatus;